import React from "react";

function HorizentalCard({ value, IconComponent, title }) {
  return (
    <div className=" mb-4">
      <div
        className="custom-card p-2"
        style={{
          backgroundColor: "#fff",
          borderRadius: "18px",
          boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
        }}
      >
        <div className="icon d-flex justify-content-center">
          <IconComponent width="55px" fill="#000" />
        </div>
        <div className="title text-white">
          <h6 className="text-center" style={{ color: "#000" }}>
            {title}
          </h6>
        </div>
        <div className="value">
          <h4 style={{ color: "#E42A3E", textAlign: "center" }}>{value}</h4>
        </div>
      </div>
    </div>
  );
}

export default HorizentalCard;
